import React from 'react';

import PropTypes from 'prop-types';

import styles from './PromoCountryItemPlain.module.css';
import { LightFlagIcon } from '../fromAuth/LightFlagIcon/LightFlagIcon';
import { PromoText } from '../promo-text/PromoText';

const PromoCountryItemPlain = (props) => {
    return (
        <a href={props.href} className={styles.countryLink}>
            <span className={styles.flagWrapper}>
                <LightFlagIcon name={props.flagName} size={'24px'} />
            </span>
            <div className={styles.countryName}>
                <PromoText tag="div" variant="subheader" color="gray40" ellipsis nowrap>
                    {props.countryName}
                </PromoText>
            </div>
        </a>
    );
};
PromoCountryItemPlain.propTypes = {
    href: PropTypes.string,
    flagName: PropTypes.string,
    countryName: PropTypes.string,
};
export default PromoCountryItemPlain;
